import { Check } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { SectionLabel, Reveal } from "./Reveal";
import { WarrantyBadge } from "./WarrantyBadge";

export const Warranty = () => {
  const { t } = useLang();
  const w = t.warranty;
  return (
    <section className="relative py-28 md:py-36" data-testid="warranty-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <Reveal className="lg:col-span-5 order-2 lg:order-1">
          <WarrantyBadge ring={w.ring} unit={w.unit} />
        </Reveal>
        <div className="lg:col-span-7 order-1 lg:order-2">
          <SectionLabel n="06">{w.label}</SectionLabel>
          <Reveal>
            <h2 className="font-display text-3xl md:text-5xl mt-8 text-[var(--text)]" data-testid="warranty-title">{w.title}</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base md:text-lg text-[var(--text)]/80 max-w-xl">{w.d}</p>
          </Reveal>
          <ul className="mt-10 grid sm:grid-cols-2 gap-4">
            {w.points.map((p, i) => (
              <Reveal key={i} delay={0.08 * i} y={20}>
                <li className="flex gap-3 items-start rounded-2xl border border-white/10 p-5 h-full transition-colors duration-300 hover:border-[var(--gold)]/60">
                  <span className="shrink-0 w-6 h-6 rounded-full bg-[var(--gold)] text-[#0A0D14] grid place-items-center"><Check className="w-3.5 h-3.5" /></span>
                  <span className="text-sm text-[var(--text)]">{p}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
